import React, { useContext } from "react";

type User = {
  email: string;
  displayName: string;
  id: string;
};

export const UserProfileContext = React.createContext<{ user: User }>(null);

export const useUser = () => {
  return useContext(UserProfileContext);
};
